import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { blue as blueStyle, red as redStyle, small as smallStyle, tag } from './styles.module.css';

/**
 * Generic tag presentational component.
 */
const Tag = ({ blue, className, red, small, link, text, ...props }) => (
  <div
    className={[small ? smallStyle : tag, blue ? blueStyle : null, red ? redStyle : null, className]
      .filter(Boolean)
      .join(' ')}
    {...props}
  >
    {link ? (<Link to={link}>{text}</Link>) : (text) }
  </div>
);

Tag.propTypes = {
  /**
   * Boolean to style blue tag.
   */
  blue: PropTypes.bool,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to style red tag.
   */
  red: PropTypes.bool,
  /**
   * Boolean to style small tag.
   */
  small: PropTypes.bool,
  /**
   * String text for the tag.
   */
  text: PropTypes.string.isRequired,
  /**
   * String link for the tag.
   */
  link: PropTypes.string,
};

Tag.defaultProps = {
  blue: false,
  className: '',
  red: false,
  small: false,
  link: undefined,
};

export default Tag;



// WEBPACK FOOTER //
// ./app/src/components/Tag/index.jsx